/* esm.sh - @radix-ui/react-avatar@1.1.11 */
export * from "/*@radix-ui/react-avatar@1.1.11/esnext/react-avatar.mjs";
